import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const FieldTitle = (props) => {
    const { title, description } = props;

    return (
        <div className={styles.container}>
            <div className={`${styles.content} ${styles.title}`}>{title}</div>
            {!!description && <div className={styles.description}>{description}</div>}
        </div>
    );
};

FieldTitle.defaultProps = {
    description: '',
};

FieldTitle.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default FieldTitle;
